export function isDonationFormEnabled() {
    return !! window?.enable_donation_form_js;
}
